import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/site/wwwroot/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
